import { render, staticRenderFns } from "./DialogIframe.vue?vue&type=template&id=c9112c34"
import script from "./DialogIframe.vue?vue&type=script&lang=js"
export * from "./DialogIframe.vue?vue&type=script&lang=js"
import style0 from "./DialogIframe.vue?vue&type=style&index=0&id=c9112c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports